import { render } from "./Resources_and_referencesView.vue?vue&type=template&id=00edc492"
import script from "./Resources_and_referencesView.vue?vue&type=script&lang=js"
export * from "./Resources_and_referencesView.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__